import ReactDOM from 'react-dom/client';
import { HashRouter, } from "react-router-dom"

import './pages/css/quasar.flex.css'
import './index.css';

import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'

import Root from './pages/Root'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider>
    <HashRouter>
      <Root />
    </HashRouter>
  </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
